module.exports = __webpack_public_path__ + "img/previous-next.e38ddd0e.png";